import { Component } from '@angular/core';

@Component({
    selector: 'app-cosif',
    templateUrl: './cosif.component.html',
    standalone: false
})
export class CosifComponent {

}
